/**
 * @generated SignedSource<<6c0a2442485e2861cde69926b098d4c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeactivateSlackIntegrationInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeactivateSlackIntegrationMutation$variables = {
  input: DeactivateSlackIntegrationInput;
};
export type DeactivateSlackIntegrationMutation$data = {
  readonly deactivateSlackIntegration: {
    readonly company: {
      readonly newSlackEnabled: boolean | null;
      readonly slackEnabled: boolean | null;
    } | null;
  } | null;
};
export type DeactivateSlackIntegrationMutation = {
  variables: DeactivateSlackIntegrationMutation$variables;
  response: DeactivateSlackIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newSlackEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeactivateSlackIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateSlackIntegrationPayload",
        "kind": "LinkedField",
        "name": "deactivateSlackIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeactivateSlackIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateSlackIntegrationPayload",
        "kind": "LinkedField",
        "name": "deactivateSlackIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6a4e33794f5f3cdabe6e4d45fc5424c",
    "id": null,
    "metadata": {},
    "name": "DeactivateSlackIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DeactivateSlackIntegrationMutation(\n  $input: DeactivateSlackIntegrationInput!\n) {\n  deactivateSlackIntegration(input: $input) {\n    company {\n      newSlackEnabled\n      slackEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d159d9e8faec4d8a125981c9ca169604";

export default node;
